var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.468,
    height: 23.254,
    viewBox: "0 0 38.468 23.254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.447,0a2.163,2.163,0,0,1,2.144,2.18V16.714a2.163,2.163,0,0,1-2.144,2.18h-.715a4.289,4.289,0,1,1-8.577,0H11.436a4.326,4.326,0,0,1-4.289,4.36,4.326,4.326,0,0,1-4.289-4.36H1.43a1.454,1.454,0,0,1,0-2.907V10.778A2.933,2.933,0,0,1,2.265,8.72L5.718,5.209A2.836,2.836,0,0,1,7.742,4.36h2.265V2.18A2.163,2.163,0,0,1,12.151,0ZM10.007,7.267H7.742L4.289,10.778v.849h5.718ZM23.588,18.894a2.145,2.145,0,1,0-2.144,2.18A2.162,2.162,0,0,0,23.588,18.894Zm-16.44-2.18a2.18,2.18,0,1,0,2.144,2.18A2.162,2.162,0,0,0,7.148,16.714Z",
    transform: "translate(0 0)",
    fill: "rgba(139,139,139,0.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.194,18.313H23.4a.644.644,0,0,0,.644-.644V14.664a.644.644,0,0,0-.644-.644H7.194V11.549A1.288,1.288,0,0,0,5,10.638L.377,15.256a1.288,1.288,0,0,0,0,1.821L5,21.7a1.288,1.288,0,0,0,2.2-.911Z",
    transform: "translate(13.429 -7.718)",
    fill: "#fa983a",
    stroke: "#fff",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckIn);
export default __webpack_public_path__ + "static/media/truck-in.071614920325ab9875daffccf2753492.svg";
export { ForwardRef as ReactComponent };